(function (w, d) {
	w.calcBottomOffset = calcBottomOffset;

	function calcBottomOffset(indent = 0) {
		const footer = d.querySelector('.js-footer');
		const footerHeight = footer.offsetHeight;
		const scrollPosition = w.scrollY + w.innerHeight;
		let offsetBottom = indent || 0;

		if (scrollPosition > footer.offsetTop) {
			offsetBottom += footerHeight;
		}
		return offsetBottom;
	}
})(window, document);
